import { BehaviorSubject, catchError, of, tap } from 'rxjs';
import { CrudApiService } from '../../core/service/abstract/rest-api.service';

export abstract class BaseEntityService<
  T extends { id: number | null },
  S extends CrudApiService<T>
> {
  protected entitySubject$ = new BehaviorSubject<T | null | null>(null);

  protected errorsSubject$ = new BehaviorSubject<Map<string, string[]> | null | null>(null);

  constructor(protected apiService: S) {}

  getError$() {
    return this.errorsSubject$.asObservable();
  }

  setError$(err: Map<string, string[]>) {
    this.errorsSubject$.next(err);
  }

  clearError$(){
    this.errorsSubject$= new BehaviorSubject<Map<string, string[]>| null | null>(null);
  }

  clearEntity$(){
    this.entitySubject$ = new BehaviorSubject<T | null | null>(null);
  }
  get entity$() {
    return this.entitySubject$.asObservable();
  }

  load(id: number) {
    this.apiService
      .get(id)
      .pipe(
        tap((item) => {
          this.entitySubject$.next(item);
        }),
        catchError((err) => {
          //TODO handle error
          console.log(err);
          return of(null);
        })
      )
      .subscribe();
  }

  save(entity: T) {
    return entity.id
      ? this.apiService.update(entity)
      : this.apiService.create(entity);
  }
}
